import React, { useState, useEffect, useRef, useContext } from 'react';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { decodeToken } from 'react-jwt';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';

import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import DevExpress from '../../../Base/Components/Tables/DevExpress/DevExpress';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
// import AutoCompleteDropdown from '../../../Base/Components/Form/AutoCompleteDropdownOld';
import AutoCompleteDropdown from '../../../Base/Components/Form/AutoCompleteDropdown';

import { getEstadosSalidaTelaCruda } from '../../../API/Global/Status/StatusRequests';
import { changeFechasTintoreria, changeStateLot, trackingLot } from '../../../API/Produccion/TrackingLot/TrackingLot';
import { decimalTemplate, textCenterTemplate } from '../../../Base/Services/TemplatesServices';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';

import './TrackingLot.scss'
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { getDateTimeStringSQL24 } from '../../../Base/Services/Moment/Luxon';
import { setDateTimeSQL } from '../../../Base/Services/FechasService';

export const TrackingLot = ({ showPC = null, setShowPC = () => { }, openDialog = false }) => {

  const toast = useRef(null);
  const calendarRefs = useRef([]);

  const { userAuth } = useContext(AuthContext);

  const [Lote, setLote] = useState({
    general: [],
    estado: [],
    estadoTable: undefined,
    procesosTable: undefined,
    rollosTable: undefined,
  });
  const [loteInfo, setLoteInfo] = useState();
  const [PC, setPC] = useState(showPC ? showPC : '');
  const [estadoPC, setEstadoPC] = useState(null);
  const [estados, setEstados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPCDialog, setShowPCDialog] = useState(false);
  const [fechaTintoreria, setFechaTintoreria] = useState(new Date())

  const getTrackingLot = async (value) => {
    console.log(value, PC)
    setLoading(true);
    // console.log(PC.replaceAll('-', ''))
    const lote = await trackingLot({
      "PC": (value ? value : PC).replaceAll('-', ''),
    })
    if (lote.RecuperarPC.length > 0) {
      console.log(lote);

      setLoteInfo(lote);

      const tempo = await getEstadosSalidaTelaCruda();
      const estado = tempo.filter(x => x.StatusName === lote.RecuperarPC[0].Estado);
      console.log({ tempo, estado });

      setEstadoPC(estado[0]);
    } else {
      setLote({
        general: [],
        estado: [],
        estadoTable: undefined,
        procesosTable: undefined,
        rollosTable: undefined,
      });
      setEstadoPC(false);
      toastShow(toast, 'warn', 'No se encontró el lote',);
      setLoading(false);
    }
  }

  const showInfo = (colum, index) => (
    <div key={colum.title + index} className={" " + colum.classColun}>
      <strong>{colum.title}</strong>
      {colum.content.map((item, index) => (
        <span key={item.input} className={'d-flex infoContainer ' + item.className}>
          <span className='infoInput'>{item.input}:</span>
          <span className='ms-2 infoValue'>
            <strong style={{ maxHeight: '100%' }}>
              {item.value}
            </strong>
          </span>
        </span>
      ))}
    </div>
  )

  const getEstados = async () => {
    const tempo = await getEstadosSalidaTelaCruda();
    setEstados(tempo);
  }

  const changeEstado = async (e) => {

    if (e?.target?.value?.IdStatus) {

      if (typeof e.target.value !== 'string') {
        confirmDialog({
          message: '¿Esta seguro que desea cambiar el estado?',
          header: 'Cambiar Estado',
          icon: 'warning',
          accept: async () => {
            setEstadoPC(e.target.value);
            const aux = {
              IdEstadoP: e.target.value.IdStatus,
              PC: PC.replaceAll('-', ''),
            }

            await changeStateLot(aux);

            toastShow(toast, 'success', 'Estado cambiado correctamente',);
          },
          reject: () => null
        })
      }
    }
  }

  const DivCargando = () => (
    <div className='XXXlarge'>
      <div className="field col-12">
        <Skeleton width="90%" height="1rem" className="mb-2"></Skeleton>
        <Skeleton width="80%" height="1rem" className="mb-2"></Skeleton>
        <Skeleton width="68%" height="1rem" className="mb-2"></Skeleton>
        <Skeleton width="70%" height="1rem" className="mb-2"></Skeleton>
        <Skeleton width="40%" height="1rem" className="mb-2"></Skeleton>
        <Skeleton width="75%" height="1rem" className="mb-2"></Skeleton>
        <Skeleton width="61%" height="1rem" className="mb-2"></Skeleton>
      </div>
    </div>
  )

  const formatPC = (e) => {

    const value = e.target.value;

    if (value.length > 8 && !value.includes('-')) { // si el valor es mayor a 8 y no contiene un -
      let tempo = value.substring(0, 8) + '-' + value.substring(8, 11) + '-' + value.substring(11, value.length);
      // console.log(tempo);
      setPC(tempo);
    } else {
      if (e?.nativeEvent.data) { // SI NO ES UN DELETE
        if (value.length <= 15) { // SI EL VALOR ES MENOR A 15
          if ([8, 12].includes(value.length)) { // AGREGA GUIONES DEPUES DE LA POSICION 8 Y 12
            setPC(value + '-');
          } else {
            setPC(value);
          }
        }
      } else {
        setPC(value);
      }
    }
    if (e.buscar) {
      getTrackingLot(value);
    }
  }

  const headerTracking = () => (
    <div className='d-flex gap' style={{ alignItems: 'center', }}>
      <h3 className='fw-bold' style={{ verticalAlign: 'middle', margin: 0, padding: 0 }}>
        Tracking Lote
      </h3>
      <span className="p-inputgroup idEncabezado encabezado__span-idEncabezado ms-4" style={{ maxWidth: 300, alignContent: 'center' }}>
        <span className=" field p-float-label" >
          <InputText id="idEncabezado" name="idEncabezado" value={PC} onChange={(e) => formatPC(e)} autoFocus placeholder='________-___-__'
            className={classNames("p-inputtext-lg block mb-2", "encabezado__id-requisa")} onKeyDown={e => e.keyCode === 13 ? getTrackingLot() : null} />
          {/* <label htmlFor="idEncabezado" >No. Lote</label> */}
        </span>
        <Button icon="pi pi-search" type="button" className="p-button-info " onClick={e => getTrackingLot()} style={{ height: 45 }}
          tooltip="Buscar PC" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} loading={loading} />
      </span>
    </div>
  )

  const cambiarFechaTintoreria = (e, item) => {
    let fechaFinal = getDateTimeStringSQL24(e)
    let tipoFecha = ['Inicio Tintorería'].includes(item?.AREA) ? 1 : 2
    let IdPartida = loteInfo?.RecuperarPC[0]?.IdPartida
    let tempoPC = loteInfo?.RecuperarPC[0]?.PC
    if (loteInfo?.RecuperarPC[0]?.IdPartida) {
      let message = <div>¿Está seguro que desea cambiar la fecha de {item?.AREA}?</div>
      confirmDialog({
        message: message,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          const result = await changeFechasTintoreria(fechaFinal, tipoFecha, IdPartida)
          console.log(result)
          if (result?.length > 0) {
            if (result[0]?.ERROR === 0) {
              toastShow(toast, 'success', result[0]?.MSJ)
              getTrackingLot(tempoPC)
            } else {
              toastShow(toast, 'error', result[0]?.MSJ)
            }
          } else {
            toastShow(toast, 'error', 'Ocurrio un error al querer actualizar la fecha')
          }
        },
        reject: () => { }
      })

    }

  }

  useEffect(() => {
    getEstados();
    setTitlePage('Tracking Lote')
    if (openDialog) {
      // SI NO SE MANDA UN LOTE, ABRE EL DIALOG PARA BUSCARLO
      setShowPCDialog(true);
    }
  }, [])

  useEffect(() => {
    if (showPC) {
      setShowPCDialog(true);
      formatPC({ target: { value: showPC, buscar: true } });
      getTrackingLot(showPC);
    }
  }, [showPC])

  useEffect(() => {
    const decoded = decodeToken(localStorage.getItem('TokenPPF'));
    if (estadoPC) {
      const loteGeneral = {
        general: [
          //  COLUMNA 1
          {
            title: '',
            classColun: 'col1',
            content: [
              {
                input: 'Partida',
                value: loteInfo.RecuperarPC[0].Partida
              },
              {
                input: 'No. Orden',
                value: loteInfo.RecuperarPC[0].Orden
              },
              {
                input: 'Ancho',
                value: loteInfo.RecuperarPC[0].Ancho
              },
              {
                input: 'Gr/Yd',
                value: loteInfo.RecuperarPC[0].GrYd
              },
            ]
          },
          {
            title: '',
            classColun: 'col2',
            content: [
              {
                input: 'Cliente',
                value: loteInfo.RecuperarPC[0].Cliente
              },
              {
                input: 'Po Cliente',
                value: loteInfo.RecuperarPC[0].PO
              },
              {
                input: 'Color',
                value: loteInfo.RecuperarPC[0].Color
              },
              {
                input: 'Gr/m2',
                value: loteInfo.RecuperarPC[0].Gm2
              },

            ]
          },
          {
            title: '',
            classColun: 'col3',
            content: [
              {
                input: 'Buyer',
                value: loteInfo.RecuperarPC[0].Buyer
              },
              {
                input: 'Labdip',
                value: loteInfo.RecuperarPC[0].LabDip
              },
              {
                input: 'Lote Hilaza',
                value: loteInfo.RecuperarPC[0].YarnLot
              },
              {
                input: 'Proceso',
                value: loteInfo.RecuperarPC[0].Proceso
              },

            ]
          },
          {
            title: '',
            classColun: 'col4',
            content: [
              {
                input: 'Estado',
                value: (
                  <div style={{}}>
                    {userAuth.IdRol === 1 ? <AutoCompleteDropdown
                      habilitar={decoded.IdRol !== 1}
                      value={estadoPC}
                      items={estados}
                      field={'StatusName'}
                      name={'Estado'}
                      handleInputChange={e => changeEstado(e)}
                      // onChange={e => changeEstado(e)}
                      tabIndex={1}
                      label={''}
                    />
                      :
                      <span>{estadoPC.StatusName}</span>
                    }
                  </div>
                )
              },
              {
                input: 'Categoría',
                value: loteInfo.RecuperarPC[0].Categoria
              },

            ]
          }
        ],
        estado: [
          {
            title: '',
            classColun: 'col-12 d-flex col5',
            content: [

              {
                input: 'Estilo',
                className: 'Estilo',
                value: loteInfo.RecuperarPC[0].Estilo
              },
              {
                input: 'Ruta',
                className: 'Ruta',
                value: loteInfo.RecuperarPC[0].Ruta
              },
              {
                input: 'Comentario Tinto',
                className: 'ComentarioTinto',
                value: loteInfo.RecuperarPC[0].Comments
              },

            ]
          },
        ],
        estadoTable: {
          scrollHeight: (loteInfo.ListaTrackingLote?.length * 33) + 36.4 + 'px',
          key: 'estadoTable',
          Data: loteInfo.ListaTrackingLote,
          filter: false,
          length: loteInfo.ListaTrackingLote.length,
          content: {
            WRoll: loteInfo.RecuperarPC[0].WRoll,
            WKg: loteInfo.RecuperarPC[0].WKg,
            WYd: loteInfo.RecuperarPC[0].WYd,
            GRoll: loteInfo.RecuperarPC[0].GRoll,
            GKg: loteInfo.RecuperarPC[0].GKg,
            GYd: loteInfo.RecuperarPC[0].GYd,
            DyeMachineName: loteInfo.RecuperarPC[0].DyeMachineName,
            Etapa: loteInfo.RecuperarPC[0].Etapa,
            KgEsperados: loteInfo.RecuperarPC[0].KgEsperados,
            DLoss: loteInfo.RecuperarPC[0].DLoss,
            Comments: loteInfo.RecuperarPC[0].Comments,
          },
        },
        procesosTable: {
          // scrollHeight: loteInfo?.ListarProcesosAcabado?.length > 10 ? '25vh' : (loteInfo?.ListarProcesosAcabado?.length * 37) + 36.4 + 'px',
          // scrollHeight: '25vh',
          key: 'Máquina',
          Data: loteInfo.ListarProcesosAcabado,
          filter: false,
          Columns: [
            {
              // Maquina
              field: 'Máquina',
              header: 'Máquina',
              className: 'Xlarge',
            },
            {
              // HoraProceso
              field: 'HoraProceso',
              header: 'Hora Proceso',
              className: 'medium',
            },
            {
              // Completo
              field: 'Completo',
              header: 'Completo',
              className: 'small',
              Format: 'Checkbox'
            },
            {
              headerName: 'Tela Cruda',
              children: [

                {
                  field: 'GRoll',
                  header: 'Rollos',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                },
                {
                  field: 'GKg',
                  header: 'Kgs',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                },
                {
                  field: 'GYd',
                  header: 'Yds',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                }

              ]
            },
            {
              headerName: 'Pesado',
              children: [
                {
                  field: 'RollosRA',
                  header: 'Rollos',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                },
                {
                  field: 'KgsRA',
                  header: 'Kgs',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                },
                {
                  field: 'LbsRA',
                  header: 'Lbs',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                },
                {
                  field: 'YdsRA',
                  header: 'Yds',
                  headerEn: '',
                  className: 'Xsmall',
                  Format: 'Currency',
                  Sumary: 'sum',
                }
              ]
            },
            {
              // Tipo
              field: 'TipoSalidaD',
              header: 'Tipo Salida',
              className: 'medium',
            },
          ]
        },
        rollosTable: {
          // scrollHeight: loteInfo?.ListaRollosAcabado?.length > 10 ? '25vh' : (loteInfo?.ListaRollosAcabado?.length * 37) + 100.4 + 'px',
          scrollHeight: '25vh',
          Data: loteInfo.ListaRollosAcabado,
          filter: false,
          clases: "tablaListados alturaListado60",
          key: 'NumeroRolloPC',
          Columns: [
            {
              // NumeroRolloPC
              field: 'NumeroRolloPC',
              header: '#',
              className: 'XXsmall',
              Sumary: 'count',
              Frozen: true,
              alignFrozen: 'left',
            },
            {
              // NumeroRollo
              field: 'NumeroRollo',
              header: 'Etiqueta',
              className: 'small',
              aling: 'center',
              Frozen: true,
              alignFrozen: 'left',
            },
            {
              // Estado
              field: 'EstadoRollo',
              header: 'Estado Rollo',
              className: 'Xsmall`',
              aling: 'center',
            },
            {
              field: 'FechaPesado',
              header: 'Fecha Pesado',
              headerEn: '',
              className: 'small',
            },
            {
              field: 'Turno',
              header: 'Turno',
              headerEn: '',
              className: 'Xsmall',
            },
            {
              field: 'NuevoAncho',
              header: 'Ancho Acabado',
              headerEn: '',
              className: 'Xsmall',
              Format: 'Center'
            },
            {
              field: 'AnchoPC',
              header: 'Ancho PC',
              headerEn: '',
              className: 'Xsmall',
            },
            {
              field: 'NGyd',
              header: 'NGyd',
              headerEn: '',
              width: 60,
              className: 'Xsmall',
            },
            {
              field: 'NGm2',
              header: 'NGm2',
              headerEn: '',
              width: 60,
              className: 'Xsmall',
            },
            {
              field: 'FechaEstadoAprobQC',
              header: 'FechaAprobQC',
              headerEn: '',
              className: 'Xsmall',
            },

            {
              field: 'NombreEstadoAprobacionQC',
              header: 'Estado QC',
              headerEn: '',
              className: '',
            },
            {
              field: 'DefectoQC',
              header: 'Defecto',
              headerEn: '',
              className: '',
            },
            {
              field: 'FacturaEntrega',
              header: 'Factura Entrega IMEX',
              headerEn: '',
              className: 'Xsmall',
            },

            {
              field: 'EntregaIMEX',
              header: 'Fecha Recibido IMEX',
              headerEn: '',
              className: 'Xsmall',
            },
            {
              field: 'FacturaImex',
              header: 'Factura Imex',
              headerEn: '',
              className: 'medium',
            },
            {
              // Kgs
              field: 'Kgs',
              header: 'Kgs',
              className: 'Xsmall',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right',
            },
            {
              // Yds
              field: 'Yd',
              header: 'Yds',
              className: 'Xsmall',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right',
            },
            {
              // Lbs
              field: 'Lbs',
              header: 'Lbs',
              className: 'Xsmall',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right',
            },
          ]
        }
      }
      setLote(loteGeneral);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadoPC])

  return (
    <Dialog
      maximized
      visible={showPCDialog}
      onHide={() => {
        setShowPC(null);
        setShowPCDialog(false)
      }}
      header={headerTracking}
    >
      <div className='px-3'>
        <ConfirmDialog />
        <Toast position="bottom-right" ref={toast} />

        <div className='cardContainerTracking' >
          <div className='border p-2'>



            <div className='trackingLot'>


              {loading ?
                (
                  <div>
                    <div className='d-flex'>
                      <DivCargando />
                      <DivCargando />
                      <DivCargando />
                    </div>
                    <br />
                    <div className='d-flex'>
                      <DivCargando />
                      <DivCargando />
                      <DivCargando />
                      <DivCargando />
                    </div>
                    <br />
                    <br />
                    <div className='d-flex'>
                      <DivCargando />
                      <DivCargando />
                      <DivCargando />
                      <DivCargando />
                      <DivCargando />
                    </div>

                  </div>
                )
                :
                (!estadoPC ? (<h5> No se han encontrado coincidencias. </h5>) : (
                  <div>

                    <div className="mx-3 trackingLot_encabezado">
                      <div className="columns">
                        {Lote.general.map(showInfo)}
                      </div>
                      {Lote.estado.map(showInfo)}
                    </div>
                    <Divider />

                    <div className="trackingLot_tableContainer">
                      <table className='table'>
                        <thead>
                          <tr>
                            <td colSpan={2} ></td>
                            <td colSpan={3} >Ordenado en Prod. Card</td>
                            <td colSpan={3} >Tela Cruda Enviada</td>
                            <td colSpan={4} ></td>
                            <td colSpan={1} >Comentarios PC</td>
                          </tr>
                          <tr>
                            <td>Área</td>
                            <td>Fecha</td>
                            <td>Rollos</td>
                            <td>Kgs</td>
                            <td>Yds</td>
                            <td>Rollos</td>
                            <td>Kgs</td>
                            <td>Yds</td>
                            <td>Maq. Tintorería</td>
                            <td>Etapa</td>
                            <td>Kg Esperados</td>
                            <td>Loss</td>
                            <td>Comments</td>
                          </tr>
                        </thead>
                        <tbody>
                          {Lote.estadoTable?.Data.map((item, index) => {
                            if (index === 0) {
                              return (
                                <tr key={item.AREA}>
                                  <td>{item.AREA}</td>
                                  <td >{item.Fecha}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Rollos' >{decimalTemplate(Lote.estadoTable?.content.WRoll)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Kgs' >{decimalTemplate(Lote.estadoTable?.content.WKg)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Yds' >{decimalTemplate(Lote.estadoTable?.content.WYd)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Rollos' >{decimalTemplate(Lote.estadoTable?.content.GRoll)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Kgs' >{decimalTemplate(Lote.estadoTable?.content.GKg)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Yds' >{decimalTemplate(Lote.estadoTable?.content.GYd)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Maq. Tintorería' >{textCenterTemplate(Lote.estadoTable?.content.DyeMachineName)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Etapa' >{textCenterTemplate(Lote.estadoTable?.content.Etapa)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Kg Esperados' >{decimalTemplate(Lote.estadoTable?.content.KgEsperados)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Loss' >{textCenterTemplate(Lote.estadoTable?.content.DLoss)}</td>
                                  <td rowSpan={Lote.estadoTable?.length} className='borderCell text-center' name='Comments' >{Lote.estadoTable?.content.Comments}</td>
                                </tr>
                              )
                            } else {
                              return (
                                <tr key={item.AREA + index}>
                                  <td>{item.AREA}</td>
                                  <td onDoubleClick={() => console.log((new Date(item?.DateLote)), item?.Fecha)}>

                                    {

                                      (['Inicio Tintorería', 'Final Tintorería'].includes(item?.AREA) && userAuth?.IdRol === 1) ?
                                        <div className='d-flex'>
                                          <Calendar
                                            ref={el => (calendarRefs.current[index] = el)}
                                            value={new Date(item?.DateLote)} //onChange={(e) => cambiarFechaTintoreria(e.value, item)} 
                                            onChange={(e) => {
                                              // console.log(e.value)
                                              // let tempoData = [...Lote?.estadoTable?.Data]
                                              // tempoData[index].DateLote = e.value
                                              setLote(prev => {
                                                const copy = { ...prev };
                                                copy.estadoTable = { ...prev.estadoTable };
                                                copy.estadoTable.Data = prev.estadoTable.Data.map((row, i) =>
                                                  i === index ? { ...row, DateLote: e.value } : row
                                                );
                                                return copy;
                                              });
                                              // setTimeout(() => {
                                              //   calendarRefs?.current[index]?.hide()
                                              // }, 1000);
                                            }}

                                            showButtonBar
                                            style={{ height: 25, fontSize: 9, width:150 }}
                                            showTime hourFormat="24" />
                                          <Button icon='ri ri-check-fill'
                                            onClick={() =>

                                              cambiarFechaTintoreria(item?.DateLote, item)

                                            } style={{ height: 25 }} />

                                        </div>
                                        :
                                        item.Fecha
                                    }

                                  </td>
                                </tr>
                              )
                            }
                          }
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className='mt-2'>
                      {/* TAB CONTAINER */}
                      <TabView >
                        {/* FINISHING TAB */}
                        <TabPanel header="Finishing">
                          <div className=''>
                            {loading ? <div className='d-flex'>
                              <DivCargando />
                              <DivCargando />
                            </div> : (
                              <div className=' trackingLot_tabTableContainer' style={{ height: '40vh' }}>
                                <AgGrid table={Lote.procesosTable} />
                                {/* <DevExpress table={Lote.procesosTable} /> */}
                              </div>
                            )}
                          </div>
                        </TabPanel>
                        {/* ROLLS TAB */}
                        <TabPanel header="Rolls">
                          <div className=''>
                            {loading ? <div className='d-flex'>
                              <DivCargando />
                            </div> : (
                              <div className=' trackingLot_tabTableContainer' style={{ margin: 'auto', height: '40vh' }}>
                                <AgGrid table={Lote.rollosTable} />
                                {/* <DevExpress table={Lote.rollosTable} /> */}
                              </div>
                            )}
                          </div>
                        </TabPanel>
                        <TabPanel header="Reprocesses">
                          <div className=''>
                            {loading ? <div className='d-flex'>
                              <DivCargando />
                            </div> : (
                              <div className=' trackingLot_tabTableContainer' style={{ margin: 'auto', height: '40vh' }}>
                                {/* <AgGrid table={Lote.rollosTable} /> */}
                              </div>
                            )}
                          </div>
                        </TabPanel>
                        <TabPanel header="Item">
                          <div className=''>
                            {loading ? <div className='d-flex'>
                              <DivCargando />
                            </div> : (
                              <div className='trackingLot_tabTableContainer' style={{ margin: 'auto', height: '40vh' }}>
                                {/* <AgGrid table={Lote.rollosTable} /> */}
                              </div>
                            )}
                          </div>
                        </TabPanel>
                      </TabView>
                    </div>

                  </div>
                ))}
            </div>
          </div>

        </div>
      </div>

    </Dialog>
  );
};

export default TrackingLot;